import React from 'react';
import SMReservationDesktopView from './SMReservationDesktopView';
import SMReservationMobileView from './SMReservationMobileView';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMReservationView extends React.Component {
  constructor(props) {
    super(props);

    // this.isMobile = SMAppHelper.isMobile();

    // DesktopでWindowの幅をモバイル並に狭めた場合にもスマフォWebと同じ表示を実現するため、
    // ヘッダー、フッターを削除する。
    // if(this.isMobile) {
    //   $('header').remove();
    //   $('footer').remove();
    // }
  }

  render() {
    return (
      <SMReservationDesktopView
        room={this.props.room}
        roomPath={this.props.roomPath}
        currentUser={this.props.currentUser}
        noImage={this.props.noImage}
        inquiry={this.props.inquiry}
        searchSessionId={this.props.searchSessionId}
      />
    );
    // if (this.isMobile) {
    //   return (
    //     <SMReservationMobileView
    //       room={this.props.room}
    //       roomPath={this.props.roomPath}
    //       currentUser={this.props.currentUser}
    //       noImage={this.props.noImage}
    //       inquiry={this.props.inquiry}
    //       searchSessionId={this.props.searchSessionId}
    //     />
    //   );
    // } else {
    //   return (
    //     <SMReservationDesktopView
    //       room={this.props.room}
    //       roomPath={this.props.roomPath}
    //       currentUser={this.props.currentUser}
    //       noImage={this.props.noImage}
    //       inquiry={this.props.inquiry}
    //       searchSessionId={this.props.searchSessionId}
    //     />
    //   );
    // }
  }
}

export default SMReservationView;



// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationView.jsx